import { Input } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useBranch } from "../../context/branch";

/**
 * Warehouse picker, fed from BranchContext so no page has to fetch the list.
 *
 * Defaults to the active branch's warehouses; pass allBranches to offer every
 * warehouse the user can reach, which is what a stock transfer needs.
 */
function WarehouseSelect({
  value,
  onChange,
  allBranches = false,
  includeInTransit = false,
  disabled = false,
  invalid = false,
  placeholder,
  name = "warehouse_id",
}) {
  const { t } = useTranslation();
  const { warehouses, branchWarehouses, branches } = useBranch();

  const source = allBranches ? warehouses : branchWarehouses;
  const options = includeInTransit
    ? source
    : source.filter((warehouse) => warehouse.type !== 'in_transit');

  const branchName = (branchId) => branches.find((b) => b.id === branchId)?.code;

  return (
    <Input
      type="select"
      name={name}
      value={value ?? ""}
      disabled={disabled}
      invalid={invalid}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{placeholder ?? t('warehouses.selectWarehouse')}</option>
      {options.map((warehouse) => (
        <option key={warehouse.id} value={warehouse.id}>
          {allBranches && branchName(warehouse.branch_id)
            ? `${branchName(warehouse.branch_id)} — ${warehouse.name}`
            : warehouse.name}
        </option>
      ))}
    </Input>
  );
}

export default WarehouseSelect;
